import * as React from 'react';
import { Text, type TextProps } from '@components/atoms/typography';
import { cn, DEFAULT_CURRENCY, DEFAULT_LOCALE, formatPrice } from '@utils';

interface PriceProps extends TextProps {
	price?: number;
	currency?: string;
	locale?: string;
	strikethrough?: boolean;
	parse?: (price: string) => string;
	negative?: boolean;
	withoutTrailingZeros?: boolean;
}

export const Price = ({
	price = NaN,
	currency = DEFAULT_CURRENCY,
	locale = DEFAULT_LOCALE,
	withoutTrailingZeros = false,
	strikethrough,
	negative,
	parse,
	asChild,
	...props
}: PriceProps) => {
	const formattedPrice = React.useMemo(() => {
		return formatPrice(price, { currency, locale, negative, withoutTrailingZeros });
	}, [price, currency, locale, negative, withoutTrailingZeros]);

	const parsedPrice = parse ? parse(formattedPrice) : formattedPrice;

	if (strikethrough) {
		props.color ??= 'darkGray';
	}

	if (asChild) {
		return <span>{parsedPrice}</span>;
	}

	return (
		<Text {...props} as="span" className={cn(props.className, strikethrough ? 'line-through' : '')} color={props.color}>
			{parsedPrice}
		</Text>
	);
};
